<div class="review-card" [class.is-hidden]="review.hidden">

    <!-- Left: Avatar + meta -->
    <div class="review-left">
        <div class="avatar">{{ review.customerInitial }}</div>
        <div class="customer-meta">
            <span class="customer-name">{{ review.customerName }}</span>
            <span class="verified-badge" *ngIf="review.isVerified">
                <i class="pi pi-verified"></i> {{ 'reviews.verifiedBuyer' | translate }}
            </span>
            <div class="stars">
                <i *ngFor="let star of starsArray" class="pi" [class.pi-star-fill]="star <= review.rating"
                    [class.pi-star]="star > review.rating"></i>
            </div>
            <span class="time-ago">{{ review.timeAgo }}</span>
        </div>
    </div>

    <!-- Middle: Content + reply area -->
    <div class="review-content">
        <h4 class="product-name">{{ review.productName }}</h4>
        <p class="review-text">{{ review.reviewText }}</p>

        <!-- Existing store reply -->
        <div class="store-reply-box" *ngIf="review.storeReply && !isEditing">
            <div class="store-reply-header">
                <span class="store-reply-label">
                    <i class="pi pi-building"></i> {{ 'reviews.storeReply' | translate }}
                </span>
                <span class="reply-date">{{ review.replyDate }} {{ 'reviews.edited' | translate }}</span>
                <div class="reply-actions">
                    <i class="pi pi-pencil pointer" (click)="startEdit()"></i>
                    <i class="pi pi-trash pointer delete-icon" (click)="deleteReply()"></i>
                </div>
            </div>
            <p class="store-reply-text">{{ review.storeReply }}</p>
        </div>

        <!-- Edit / New reply textarea -->
        <div class="reply-compose" *ngIf="isReplying || isEditing">
            <div class="compose-avatar">{{ 'S' }}</div>
            <div class="compose-body">
                <textarea class="reply-textarea" [placeholder]="'reviews.writeReplyPlaceholder' | translate" [(ngModel)]="replyText"
                    rows="3"></textarea>
                <div class="compose-actions">
                    <button class="cancel-btn" (click)="cancelReply()">{{ 'reviews.cancel' | translate }}</button>
                    <button class="gradient-button send-reply-btn" (click)="sendReply()" [disabled]="!replyText.trim()">
                        {{ 'reviews.sendReply' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Right: Actions -->

    <!-- PENDING actions -->
    <div class="review-actions" *ngIf="review.status === 'Pending'">
        <button class="action-btn approve-btn" (click)="approve()">
            <i class="pi pi-check"></i> {{ 'reviews.approve' | translate }}
        </button>
        <button class="action-btn decline-btn" (click)="decline()">
            <i class="pi pi-times"></i> {{ 'reviews.decline' | translate }}
        </button>
    </div>

    <!-- APPROVED actions -->
    <div class="review-actions" *ngIf="review.status === 'Approved'">
        <button class="action-btn reply-btn" [class.replied]="!!review.storeReply" (click)="toggleReply()"
            [disabled]="!!review.storeReply">
            <i class="pi pi-reply"></i> {{ 'reviews.reply' | translate }}
        </button>
        <button class="action-btn hide-btn" (click)="toggleHide()">
            <i class="pi" [class.pi-eye-slash]="!review.hidden" [class.pi-eye]="review.hidden"></i>
            {{ review.hidden ? ('reviews.show' | translate) : ('reviews.hide' | translate) }}
        </button>
    </div>

    <!-- DECLINED actions -->
    <!-- DECLINED actions -->
    <div class="review-actions" *ngIf="review.status === 'Declined'">
        <button class="action-btn delete-btn" (click)="deleteReview()">
            <i class="pi pi-trash"></i> {{ 'reviews.remove' | translate }}
        </button>
    </div>

    <!-- Confirmation overlay -->
    <div class="confirm-overlay" *ngIf="showDeleteConfirm">
        <div class="confirm-dialog">
            <i class="pi pi-exclamation-triangle confirm-icon"></i>
            <h4 class="confirm-title">{{ 'reviews.removeReviewTitle' | translate }}</h4>
            <p class="confirm-message">{{ 'reviews.removeReviewDesc' | translate }}</p>
            <div class="confirm-actions">
                <button class="cancel-btn" (click)="cancelDelete()">{{ 'reviews.cancel' | translate }}</button>
                <button class="action-btn delete-btn" (click)="confirmDelete()">
                    <i class="pi pi-trash"></i> {{ 'reviews.remove' | translate }}
                </button>
            </div>
        </div>
    </div>

</div>